import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import SideBarWhite from "../../assets/images/logo-white.png";
import UCCLogo from "../../assets/images/logo.png";

class Sidebar extends Component {
  state = {};
  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/projects", state: "projectsMenuOpen" },
      { path: "/admin", state: "adminMenuOpen" },
      { path: "/admin/users/add", state: "adminMenuOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  render() {
    let project = sessionStorage.getItem("project_id");
    let isAdmin = sessionStorage.getItem('user_role') ==='Admin'

    return (
      <nav className="sidebar sidebar-offcanvas " id="sidebar">
        <div className="sidebar-brand-wrapper center-div d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="/">
            <img
              src={SideBarWhite}
              style={{ height: "60px", width: "180px", marginRight: "10px" }}
              alt="logo"
            />
          </a>
          <a className="sidebar-brand  brand-logo-mini" href="/">
            <img
              src={UCCLogo}
              alt="mini logo"
              style={{ height: "60px", width: "60px" }}
            />
          </a>
        </div>
        <ul className="nav">
          <li className="nav-item nav-category">
            <span className="nav-link">Navigation</span>
          </li>
          <li
            className={
              this.isPathActive("/dashboard")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon">
                <i className="text-white mdi mdi-speedometer"></i>
              </span>
              <span className="menu-title text-white">Dashboard</span>
            </Link>
          </li>
          <li
            className={
              this.isPathActive("/projects")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                this.state.projectsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("projectsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="text-white mdi mdi-laptop"></i>
              </span>
              <span className="menu-title text-white">Projects</span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={this.state.projectsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive(
                          "/projects/create/general-information"
                        )
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/create/general-information"
                    >
                      Add New
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/projects/view/all")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/view/all"
                    >
                      All Projects
                    </Link>
                  </li>
                  {project && (
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/projects/view/drafts")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/projects/view/drafts"
                      >
                        Recent
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
          <li
            className={
              this.isPathActive("/plans-and-budgets")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                this.state.tablesMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("tablesMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="text-white mdi mdi-table-large"></i>
              </span>
              <span className="menu-title text-white">Plans & Budgets</span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={this.state.tablesMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/projects/workplans/create")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/workplans/create"
                    >
                      Create
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/projects/workplans/all")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/workplans/all"
                    >
                      View all
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
          <li
            className={
              this.isPathActive("/charts")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                this.state.chartsMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("chartsMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="text-white mdi mdi-chart-bar"></i>
              </span>
              <span className="menu-title text-white">Reports</span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={this.state.chartsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/projects/reports/performance")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/reports/performance"
                    >
                      Performance
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive(
                          "/projects/reports/beneficiary-performance"
                        )
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/projects/reports/beneficiary-performance"
                    >
                      Beneficiary
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/reports/ad-hoc")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/reports/ad-hoc"
                    >
                     Ad hoc Reports
                    </Link>
                  </li> */}
                </ul>
              </div>
            </Collapse>
          </li>
          {isAdmin &&
            <li
              className={
                this.isPathActive("/admin")
                  ? "nav-item menu-items active"
                  : "nav-item menu-items"
              }
            >
              <div
                className={
                  this.state.adminMenuOpen ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("adminMenuOpen")}
                data-toggle="collapse"
              >
                <span className="menu-icon">
                  <i className="text-white mdi mdi-shield-account-outline text-white"></i>
                </span>
                <span className="menu-title text-white">Admin</span>
                <i className="text-white menu-arrow"></i>
              </div>
              <Collapse in={this.state.adminMenuOpen}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/users/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/users/add"
                      >
                        Users
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/financial-years")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/financial-years"
                      >
                        Financial Years
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/service-areas/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/service-areas/add"
                      >
                        Service areas
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/ucusaf-phases/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/ucusaf-phases/add"
                      >
                        UCUSAF phases
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/fund-currencies/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/fund-currencies/add"
                      >
                        Currencies
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/resource-categories/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/resource-categories/add"
                      >
                        Resource categories
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/project-funders/add")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/project-funders/add"
                      >
                        Funders
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/edit-logs")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/edit-logs"
                      >
                        Edit Logs
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/audit-logs")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/audit-logs"
                      >
                        Audit Logs
                      </Link>
                    </li>
                    <li className="nav-item">
                      {" "}
                      <Link
                        className={
                          this.isPathActive("/admin/set-sso-credentials")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/admin/set-sso-credentials"
                      >
                        AD Setup
                      </Link>
                    </li>
                  </ul>
                </div>
              </Collapse>
            </li>
          }
          {/*  <li className={ this.isPathActive('/icons') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.iconsMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('iconsMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="text-white mdi mdi-contacts"></i>
              </span>
              <span className="menu-title text-white"><Trans>Icons</span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={ this.state.iconsMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={ this.isPathActive('/icons/mdi') ? 'nav-link active' : 'nav-link' } to="/icons/mdi"><Trans>Material</Link></li>
                </ul>
              </div>
            </Collapse>
          </li>
          <li className={ this.isPathActive('/profile') ? 'nav-item menu-items active' : 'nav-item menu-items' }>
            <div className={ this.state.userPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } onClick={ () => this.toggleMenuState('userPagesMenuOpen') } data-toggle="collapse">
              <span className="menu-icon">
                <i className="text-white mdi mdi-security"></i>
              </span>
              <span className="menu-title text-white"><Trans>User Pages</span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={ this.state.userPagesMenuOpen }>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={ this.isPathActive('/profile/login-1') ? 'nav-link active' : 'nav-link' } to="/profile/login-1"><Trans>Login</Link></li>
                  <li className="nav-item"> <Link className={ this.isPathActive('/profile/register-1') ? 'nav-link active' : 'nav-link' } to="/profile/register-1"><Trans>Register</Link></li>
                </ul>
              </div>
            </Collapse> 
          </li> */}
          {/* <li className="nav-item nav-category">
            <span className="nav-link">
             More
            </span>
          </li>
          <li
            className={
              this.isPathActive("/notes")
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <div
              className={
                this.state.errorPagesMenuOpen
                  ? "nav-link menu-expanded"
                  : "nav-link"
              }
              onClick={() => this.toggleMenuState("errorPagesMenuOpen")}
              data-toggle="collapse"
            >
              <span className="menu-icon">
                <i className="text-white mdi mdi-lock"></i>
              </span>
              <span className="menu-title text-white">
               Tools
              </span>
              <i className="text-white menu-arrow"></i>
            </div>
            <Collapse in={this.state.errorPagesMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/notes")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/notes"
                    >
                      Notes
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/todos")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/todos"
                    >
                      To dos
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li> */}
          {/* <li className="nav-item menu-items">
            <a className="nav-link" href="" rel="noopener noreferrer" target="_blank">
              <span className="menu-icon">
                <i className="text-white mdi mdi-file-document-box"></i>
              </span>
              <span className="menu-title text-white"><Trans>Documentation</span>
            </a>
          </li> */}
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withRouter(Sidebar);
